import React from "react";
import "./Hero.css";
import Header from "../Header/Header";
import coracao from "../../assets/coracao.png";
import hero from "../../assets/hero_image.png";
import heroblack from "../../assets/hero-image-black.png";
import calories from "../../assets/calorias.png";
import NumberCounter from "number-counter";
import {motion} from 'framer-motion';
const Hero = () => {
  const transition = {type: 'spring', duration: 3}
  const mobile = window.innerWidth<=768 ? true : false
  return (
    <div className="hero" id="home">

      <div className="blur hero-blur"></div>
      <div className="left-h">
        <Header />
        {/* o melhor and */}
        <div className="the-best-ad">
          <motion.div
          initial={{left: mobile? '165px': '238px'}}
          whileInView={{left: '8px'}}
          transition={{...transition, type: 'tween'}}
          ></motion.div>
          <span>A melhor academia da cidade</span>
        </div>

        {/* titulo de heroi */}
        <div className="hero-text">
          <div>
            <span className="stroke-text">Seu </span>
            <span>Shape</span>
          </div>
          <div>
            <span> Corpo Ideal</span>
          </div>
          <div className="span">
            <span>
              Aqui vamos ajudá-lo a moldar e construir o seu corpo ideal e viver
              a sua vida ao máximo
            </span>
          </div>
        </div>

        {/* Figuras */}
        <div className="figures">
          <div>
            <span>
              <NumberCounter end={140} start={100} delay='4' preFix='+'/>
            </span>
            <span>Treinadores especializados</span>
          </div>
          <div>
            <span>
              <NumberCounter end={978} start={800} delay='4' preFix='+'/>
            </span>
            <span>membros aderiram</span>
          </div>
          <div>
            <span>
              <NumberCounter end={50} start={0} delay='4' preFix='+'/>
            </span>
            <span>Programas de condicionamento físico</span>
          </div>
        </div>
        {/* Botoes hero */}
        <div className="hero-buttons">
            <button className="btn">Começar</button>
            <button className="btn">Saiba mais</button>
        </div>
      </div>
      <div className="right-h">
        <button className="btn">Acesse agora</button>
        <motion.div className="heart-rate"
        initial={{right: "-1rem"}}
        whileInView={{right: "4rem"}}
        transition={transition}>
          <img src={coracao} alt="" />
          <span>Frequência Cardíaca</span>
          <span>116 bpm</span>
        </motion.div>

        {/* hero imagens */}
        <img src={hero} alt="" className="hero-image" />
        <motion.img 
        initial={{right: '11rem'}}
        whileInView={{right: '20rem'}}
        transition={transition}
        src={heroblack} alt="" className="hero-image-black"/>

        {/* Calorias */}
        <motion.div className="calories"
        initial={{right: "37rem"}}
        whileInView={{right: "28rem"}}
        transition={transition}>
          <img src={calories} alt="" />
          <div>
            <span>calorias Queimadas</span>
            <span>220 kcal</span>
          </div>
        </motion.div>
      </div>
    </div>
  );
};
export default Hero;
